import axios from 'axios';

import { ACTIONS } from '../actions';
import i18n from '../../i18n';

export const getShopInfo = (shopId, typeId = 1) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_SHOP_INFO_START, payload: { shop: { loading: true } } });
    axios
      .get(`/users/unused/shops/${shopId}?type_id=${typeId}`)
      .then((res) => {
        const shopData = res.data.data.shop;
        dispatch({
          type: ACTIONS.GET_SHOP_INFO_SUCCESS,
          payload: {
            shop: {
              id: parseInt(shopId, 10),
              loading: false,
              name: shopData.first_name + ' ' + shopData.last_name,
              address: shopData.address,
              postcode: shopData.post_code,
              latitude: shopData.lat,
              longitude: shopData.lng,
            },
            schedules: res.data.data.schedules,
            slots: res.data.data.slots,
          },
        });
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.GET_SHOP_INFO_FAILURE,
          payload: {
            shop: {
              loading: false,
              error: 'failed to get shop',
            },
            schedules: [],
            slots: [],
          },
        });
      });
  };
};

export const getEvent = (eventSlug) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_EVENT_START, payload: { event: { loading: true } } });
    axios
      .get(`/events/by-slug/${eventSlug}`)
      .then((res) => {
        const eventData = res.data.data;
        dispatch({
          type: ACTIONS.GET_EVENT_SUCCESS,
          payload: {
            event: {
              id: parseInt(eventData.id, 10),
              companyId: eventData.company_id,
              loading: false,
              name: eventData.name,
              responsibleFullName: eventData.responsible_full_name,
              responsibleEmail: eventData.responsible_email,
              location: eventData.location,
              contactPersonFullName: eventData.contact_person_full_name,
              contactPersonPhone: eventData.contact_person_phone,
              contactPersonEmail: eventData.contact_person_email,
              // Store raw event descriptions and places for dynamic switching
              rawEventDescriptionEng: eventData.event_description,
              rawEventDescription: eventData.event_description_sv,
              rawPlaceEng: eventData.place,
              rawPlace: eventData.place_sv,
              buddyId: eventData.buddy_id,
              buddyName: eventData.buddy_name,
              logo: eventData.logo,
              eventStatusId: eventData.event_status_id,
              serviceSlotId: eventData.service_slot_id,
              createdAt: eventData.created_at,
              updatedAt: eventData.updated_at,
            },
          },
        });
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.GET_EVENT_FAILURE,
          payload: {
            event: {
              loading: false,
              error: e?.response?.data?.error?.message || 'Failed to fetch event',
            },
          },
        });
      });
  };
};

export const getEventSlots = (slug) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_EVENT_SLOTS_START });

    try {
      const response = await axios.get(`/event-slots/by-slug/${slug}/availability?per_page=50`);

      if (!response.data.data.results) {
        return;
      }
      dispatch({
        type: ACTIONS.GET_EVENT_SLOTS_SUCCESS,
        payload: {
          slots: response.data.data.results.sort(
            (a, b) => new Date(a.start_time) - new Date(b.start_time)
          ),
        },
      });
    } catch (error) {
      dispatch({
        type: ACTIONS.GET_EVENT_SLOTS_FAILURE,
        payload:
          error.response?.data?.error?.message || error.message || 'Failed to fetch event slots',
      });
    }
  };
};

export const getServiceSlot = (slotId) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_SERVICE_SLOT_START });
    try {
      const response = await axios.get(`/events/service_slots/${slotId}`);
      dispatch({
        type: ACTIONS.GET_SERVICE_SLOT_SUCCESS,
        payload: response.data.data,
      });
    } catch (error) {
      dispatch({
        type: ACTIONS.GET_SERVICE_SLOT_FAILURE,
        payload: error.response?.data?.error?.message || 'Failed to fetch service slot',
      });
    }
  };
};

export const submitUserDetails = (user) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.USER_DETAILS_SUBMIT, payload: user });
  };
};

export const submitBookingInfo = (booking) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.BOOKING_DETAILS_SUBMIT, payload: booking });
  };
};

export const startLoading = () => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_START, payload: {} });
  };
};
export const stopLoading = () => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_FAILURE, payload: null });
  };
};

export const submitPurchase = (service, stripeToken, stripeElement, stripe, history) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_START, payload: {} });
    axios
      .post('/account/blocket-register', {
        first_name: service.user.first_name,
        last_name: service.user.last_name,
        email: service.user.email,
        phone_number: service.user.phone_number,
        address: service.user.address,
        post_code: service.user.post_code,
        stripe_token: stripeToken,
        service_date: service.booking.date,
        slot_id: service.booking.service_slot_id,
      })
      .then((res) => {
        const intent = res.data.data.intent;
        if (intent.next_action && intent.next_action.type === 'use_stripe_sdk') {
          stripe
            .confirmCardPayment(intent.client_secret, {
              payment_method: {
                card: stripeElement,
              },
            })
            .then((res) => {
              if (res.error) {
                dispatch({
                  type: ACTIONS.SUBMIT_PURCHASE_FAILURE,
                  payload: res.error,
                });
              } else {
                dispatch({ type: ACTIONS.SUBMIT_PURCHASE_SUCCESS, payload: {} });
                history.push('/success');
              }
            });
        } else {
          dispatch({ type: ACTIONS.SUBMIT_PURCHASE_SUCCESS, payload: {} });
          history.push('/success');
        }
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.SUBMIT_PURCHASE_FAILURE,
          payload: e?.response?.data?.error?.cause,
        });
      });
  };
};

export const submitBooking = (service, history, typeId = 1) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_START, payload: {} });
    await new Promise((r) => setTimeout(r, 2000));
    // if postcode change(or if they are not unique) then we need change logic on API route also
    axios
      .post('/account/blocket-register', {
        first_name: service?.user.first_name,
        last_name: service?.user.last_name,
        email: service?.user.email,
        phone_number: service?.user.phone_number && `+46${service?.user.phone_number}`,
        address: service?.user?.address?.value ?? service?.shop?.address,
        post_code: service?.user?.address?.postcode ?? service?.shop?.postcode,
        latitude: service?.user?.address?.latitude ?? service?.shop?.latitude,
        longitude: service?.user?.address?.longitude ?? service?.shop?.longitude,
        note: service?.user?.note ? `user note: ${service?.user?.note}` : '',
        service_date: service?.booking.date,
        buddy_id: service?.shop?.id,
        shop_name: service?.shop?.name,
        slot_id: service?.booking.service_slot_id,
        type_ids: [typeId],
      })
      .then(() => {
        dispatch({ type: ACTIONS.SUBMIT_PURCHASE_SUCCESS, payload: {} });
        history.push('/success');
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.SUBMIT_PURCHASE_FAILURE,
          payload: e?.response?.data?.error?.cause || 'Something went wrong, try again',
        });
      });
  };
};

export const submitEventBooking = (formData, history) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_EVENT_BOOKING_START });

    const bookingData = {
      event_id: formData.event_id,
      event_slot_id: formData.event_slot_id,
      first_name: formData.first_name,
      last_name: formData.last_name,
      given_company: formData.given_company,
      given_email: formData.given_email,
      comments_to_mechanic: formData.comments_to_mechanic,
      phone_number: formData.phone_number && `+46${formData.phone_number}`,
      status_id: formData.status_id,
      language: formData.language || i18n.resolvedLanguage || 'sv',
    };

    try {
      const response = await axios.post('/event-bookings/public/', bookingData);
      dispatch({
        type: ACTIONS.SUBMIT_EVENT_BOOKING_SUCCESS,
        payload: response.data,
      });
      history.push('/success');
    } catch (error) {
      dispatch({
        type: ACTIONS.SUBMIT_EVENT_BOOKING_FAILURE,
        payload: error.response?.data?.error?.message || 'Failed to submit event booking',
      });
    }
  };
};

export const submitEventWaitlist = (formData, history) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_EVENT_WAITLIST_START });

    const waitlistData = {
      event_id: formData.event_id,
      first_name: formData.first_name,
      last_name: formData.last_name,
      given_company: formData.given_company,
      given_email: formData.given_email,
      comments_to_mechanic: formData.comments_to_mechanic,
      phone_number: formData.phone_number && `+46${formData.phone_number}`,
      status_id: formData.status_id,
      language: formData.language || i18n.resolvedLanguage || 'sv',
    };

    try {
      const response = await axios.post('/event-bookings/public/', waitlistData);
      dispatch({
        type: ACTIONS.SUBMIT_EVENT_WAITLIST_SUCCESS,
        payload: response.data,
      });
      history.push('/success');
    } catch (error) {
      dispatch({
        type: ACTIONS.SUBMIT_EVENT_WAITLIST_FAILURE,
        payload: error.response?.data?.error?.message || 'Failed to submit waitlist entry',
      });
    }
  };
};

export const cancelBooking = (token) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.CANCEL_BOOKING_START, payload: null });
    axios
      .post('/account/cancel-blocket-booking', {
        token: token,
      })
      .then((res) => {
        dispatch({ type: ACTIONS.CANCEL_BOOKING_SUCCESS, payload: null });
      })
      .catch((error) => {
        dispatch({
          type: ACTIONS.CANCEL_BOOKING_FAILURE,
          payload: error.response?.data?.error?.message || 'Failed to cancel booking',
          /*payload: e?.response?.data?.error?.cause,*/
        });
      });
  };
};
